import React, { useState } from 'react';
import { applyCdnUrl } from '../utils/site-utils';
import Label from '../utils/label';

const chinaviewTerminatePopup = () => {

    let stage = localStorage.getItem('disabledChinaViewTerminate');

    const [disabledTerminatePopup, setDisabledTerminatePopup] = useState(stage ? stage : false)

    const closePopup = () => {
        localStorage.setItem('disabledChinaViewTerminate', true);
        setDisabledTerminatePopup(true)
    }

    return (
        disabledTerminatePopup 
        ? <></>
        :(
            <div className="l-modal l-modal--terminate">
                <div className="l-modal-overlay" onClick={() => closePopup()}></div>
                <div className="l-terminate">
                    <div className="l-terminate__wrap">
                        <div className="l-terminate__header">
                            <div className="l-terminate-img">
                                <img src={applyCdnUrl('/NewAsiaSkin/CommIndex/_global-L/china-terminate-popup/images/ringtone.png')} />
                            </div>
                        </div>
                        
                        <div className="l-terminate__main">
                            <div className="l-terminate__title">{Label.lbl_Dear_Valued_Customers}</div>
                            <div className="l-terminate__text">{Label.lbl_Chinaview_Terminate}</div>
                        </div>

                        <div className="l-terminate__footer">
                            <button className="l-terminate-btn" onClick={() => closePopup()}>{Label.lbl_AcceptKnown}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    )
}

export default chinaviewTerminatePopup;